import { ModalAddCa2Component } from './../../../shared/components/modals/modal-add-ca2/modal-add-ca2.component';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { Component, EventEmitter, Injector, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { Ca2Model } from 'src/app/shared/models/societe-linked/ca2.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { Ca2Service } from 'src/app/shared/services/societe-linked/ca2.service';
import { TrieTabService } from 'src/app/shared/services/utilities/trie-tab.service';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { Ca1Service } from 'src/app/shared/services/societe-linked/ca1.service';

@Component({
  selector: 'app-gestion-ca2',
  templateUrl: './gestion-ca2.component.html',
  styleUrls: ['./gestion-ca2.component.scss']
})
export class GestionCa2Component {

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();
  societe: SocieteModel;
  mySubscription: any;
  result = false;
  loading = false;
  selectedAction: Ca2Model;
  displayedColumns: string[] = ['code', 'libelle', 'ca1','imputable', 'action'];
  dataSource: Ca2Model[];
  matDataSource = new MatTableDataSource<Ca2Model>();
  pageEvent: PageEvent;
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageIndex: number;
  pageSize = 25;
  ca2s: Ca2Model[] = [];
  ca1s: Ca1Model[] = [];
  droitLevel = 0;
  objet: SimpleQueryUser = new SimpleQueryUser();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private comp: TrieTabService,
    injector: Injector,
    private route: ActivatedRoute,
    private ca1Service: Ca1Service,
    private ca2Service: Ca2Service,
    private societeService: SocieteService,
    private toastrService: ToastrService,
    private gestionReferentielComponent: GestionReferentielComponentService
  )
  {
    this.route.params.subscribe((params: any) => {
      if (params.id === '0') {
        this.toastrService.error('Erreur durant la récupération du ca2.', 'Erreur');
        this.router.navigate(['/']);
      } else {
        this.societeService.get(params.id).subscribe((societe: SocieteModel) => {
          if (societe) {
            this.societe = societe;
            this.objet.query = '';
            this.objet.pageNumber = 0;
            this.objet.pageSize = this.pageSize;
            this.objet.order = 'libelle';
            this.matDataSource.paginator = this.paginator;
            this.loadPage();
            this.ca1Service.getFromSociete(societe.id).subscribe(ca1s => {
              this.ca1s = ca1s;
            });
          }
        });
      }
    });

    this.router.routeReuseStrategy.shouldReuseRoute = function() {
       return false;
     };
    this.mySubscription = this.router.events.subscribe((event) => {
       if (event instanceof NavigationEnd) {
         this.router.navigated = false;
       }
     });
  }

  getCa1ByCode(code: string): string{
    const c = this.ca1s.find(ca1 => ca1.code === code);
    if (c) {
      return c.code + '-' + c.libelle;
    } else if (code) {
      return code;
    } else {
      return '';
    }
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateCa2FormGroup();
    form.get('idSociete').setValue(this.societe.id);
    const dialogRef = this.dialog.open(ModalAddCa2Component, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          ca2s: this.ca2s,
          ca1s: this.ca1s,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.loadPage();
        }
      });

  }

  onModify(ca2: Ca2Model): void {
    const form = this.gestionReferentielComponent.getEditCa2FormGroup(ca2);
    const dialogRef = this.dialog.open(ModalAddCa2Component, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          ca1s: this.ca1s,
          form,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.loadPage();
        }
      });
  }


  onDelete(ca2: Ca2Model): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression du ca2',
        message: 'Êtes-vous sur de vouloir supprimer le ca2 ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.ca2Service.delete(ca2.id).subscribe((response: Ca2Model) => {
          this.toastrService.success('Le ca2 a bien été supprimé');
          this.loadPage();
        });
      }
    });
  }

  orderUsers(ca2s: Ca2Model[]): Ca2Model[] {
    ca2s = ca2s.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -2;
      }
    });
    return ca2s;
  }


  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    referentiel.idSociete = this.societe.id;
    this.ca2Service.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<Ca2Model>) => {
      if (query.objets != null) {
        this.ca2s = query.objets;
      } else {
        this.ca2s = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<Ca2Model>(this.ca2s);
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }

}
